import "rc-time-picker/assets/index.css";
import TimePicker from "rc-time-picker";
import ButtonIcon from "./buttonIcon";
import { Common } from "../../services/Common";

const InputFiled = (props: any) => {
  let valueInput = props.value ?? "";
  let type = props.type ?? "text";
  let placeholder = props.placeholder ?? "";
  let name = props.name ?? "";
  let min = props.min ?? "";
  let max = props.max ? props.max : "";
  let disabled = props.disabled ?? false;
  let readOnly = props.readOnly ?? false;
  const UpdadeValue = (valueInput: any) => {
    if (!readOnly) {
      props.handleChange(valueInput);
    }
  };

  const onChangeTime = (value: any) => {
    UpdadeValue(value.format("HH:mm"));
  };

  return type === "time" ? (
    <>
      <div className="timePicker">
        <TimePicker
          disabled={disabled}
          placeholder="00:00"
          value={Common.convertStringToDate(valueInput)}
          onChange={onChangeTime}
          showSecond={false}
        />
        <ButtonIcon disabled={disabled} icon={"schedule"} />
      </div>
    </>
  ) : (
    <input
      type={type}
      disabled={disabled}
      readOnly={readOnly}
      min={min}
      max={max}
      name={name}
      id={name}
      value={valueInput}
      placeholder={placeholder}
      onChange={(e) => UpdadeValue(e.target.value)}
      onBlur={(e) => UpdadeValue(e.target.value)}
      onFocus={(e) => UpdadeValue(e.target.value)}
      className={`form-control Input ${props.className}`}
    />
  );
};

export default InputFiled;
